import { render, staticRenderFns } from "./EditarNotaEnfermeria.vue?vue&type=template&id=4ecb80e8&scoped=true"
import script from "./EditarNotaEnfermeria.vue?vue&type=script&lang=js"
export * from "./EditarNotaEnfermeria.vue?vue&type=script&lang=js"
import style0 from "./EditarNotaEnfermeria.vue?vue&type=style&index=0&id=4ecb80e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecb80e8",
  null
  
)

export default component.exports